module.exports = __webpack_public_path__ + "static/media/hall-P3.4ce06014.svg";